import { render, staticRenderFns } from "./Classifier.vue?vue&type=template&id=6f7c8702&scoped=true&"
import script from "./Classifier.vue?vue&type=script&lang=js&"
export * from "./Classifier.vue?vue&type=script&lang=js&"
import style0 from "./Classifier.vue?vue&type=style&index=0&id=6f7c8702&lang=scss&scoped=true&"
import style1 from "./Classifier.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7c8702",
  null
  
)

export default component.exports